
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PresentationSection from './components/PresentationSection';
import SolutionsSection from './components/SolutionsSection';
import PhilosophySection from './components/PhilosophySection';
import TeamSection from './components/TeamSection';
import ResultsSection from './components/ResultsSection';
import CTASection from './components/CTASection';

export default function About() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <PresentationSection />
        <SolutionsSection />
        <PhilosophySection />
        <TeamSection />
        <ResultsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
